import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createElement, memo, } from 'react';
import { PopoverManager } from '../Popover/index';
import { sizes } from './constants';
import { DropdownIconStateless } from './DropdownIconStateless';
const defaultProps = {
    size: sizes.medium,
    zIndex: 999999,
};
const DropdownIcon = ({ children, icon, size = defaultProps.size, zIndex = defaultProps.zIndex, }) => (_jsx(PopoverManager, { children: ({ closePopover, contentRef, isOpen, targetRef, togglePopover, }) => (_jsx(DropdownIconStateless, Object.assign({ contentRef: contentRef, icon: icon, open: isOpen, size: size, targetRef: targetRef, toggleDropdown: togglePopover, zIndex: zIndex }, { children: typeof children === 'function'
            ? createElement(children, {
                closeDropdown: closePopover,
            })
            : children }))) }));
const MemoizedDropdownIcon = memo(DropdownIcon);
export { MemoizedDropdownIcon as DropdownIcon };
// MC-1068 Temporary hack for Storybook.
export default DropdownIcon;
